import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Schema, SchemaInfo, SchemaResult, SchemaType, SetAssistedAccessDto } from '../models/schema.model';
import { FormIoDataResponse } from '../models/formio.model';
import { FormSubmission } from '../models/formSubmission.model';
import { CreatePdfDto } from '../models/create-pdf.model';

@Injectable({
    providedIn: 'root'
})
export class SchemaService {
    constructor(private readonly http: HttpClient) { }

    getSchemaById(schemaId: number): Observable<Schema> {
        return this.http.get<Schema>(`${environment.backendUrl}/schema/getschema`, { params: { schemaId } })
    }

    getSchemaInfoById(schemaId: number): Observable<SchemaInfo> {
        return this.http.get<SchemaInfo>(`${environment.backendUrl}/schema/getschemainfo`, { params: { schemaId } })
    }

    getHasFogPForms(): Observable<boolean> {
        return this.http.get<boolean>(`${environment.backendUrl}/schema/HasFogpForms`)
    }

    getFormIoSchemaById(schemaId: number): Observable<FormIoDataResponse> {
        return this.http.get<FormIoDataResponse>(`${environment.backendUrl}/schema/getformioSchema`, { params: { schemaId } })
    }

    postSchemasByUserId(): Observable<Schema[]> {
        return this.http.post<Schema[]>(`${environment.backendUrl}/schema/schemasbyuserid`, null)
    }

    postPatientActiveSchemas(): Observable<Schema[]> {
        return this.http.post<Schema[]>(`${environment.backendUrl}/schema/patientactiveschemas`, null)
    }

    postPatientHistoricalSchemas(): Observable<Schema[]> {
        return this.http.post<Schema[]>(`${environment.backendUrl}/schema/patienthistoricalschemas`, null)
    }

    postPatientOtherSchemas(): Observable<Schema[]> {
        return this.http.post<Schema[]>(`${environment.backendUrl}/schema/patientotherschemas`, null)
    }

    postPatientOtherCompletedSchemas(): Observable<Schema[]> {
        return this.http.post<Schema[]>(`${environment.backendUrl}/schema/PatientOtherCompletedChildrenSchemasByCpr`, null)
    }

    postSchemaResult(schemaId: number, schemaResult: SchemaResult): Observable<SchemaResult> {
        return this.http.post<SchemaResult>(`${environment.backendUrl}/schema/${schemaId}/result`, schemaResult)
    }

    getSchemaResult(schemaId: number): Observable<Object> {
        return this.http.get(`${environment.backendUrl}/schema/${schemaId}/result`)
    }

    submitForm(submission: FormSubmission): Observable<string> {
        return this.http.post<string>(`${environment.backendUrl}/schema/Submit`, submission).pipe(
            map((result: string) => result.toLowerCase())
        );
    }

    postSetAssistedCprInProgress(submission: SetAssistedAccessDto): Observable<boolean> {
        return this.http.post<boolean>(`${environment.backendUrl}/schema/SetAssistedAccess`, submission)
    }

    getPdfFile(schemaId: number, customProperties: Map<string, string>, data: any) {
        
        var createPdfDto: CreatePdfDto = {
            customProperties: customProperties,
            data: data
        }
        return this.http.post(`${environment.backendUrl}/schema/GetPdfFile/${schemaId}`, createPdfDto, { responseType: 'blob' }); // Fetch as Blob
    }

    getSchemaTypes$(): Observable<SchemaType[]> {
        return this.http.get<SchemaType[]>(`${environment.backendUrl}/schema/getschematypes`)
    }

    postDeleteSchema$(schemaId: number): Observable<boolean> {
        return this.http.post<boolean>(`${environment.backendUrl}/schema/deleteschema/${schemaId}`, null);
    }
}
